import React, { useEffect, useState } from "react";
import { useApp } from "../context/AppContext";
import api from "../api";
import { Card, CardContent, CardHeader, CardTitle } from "../components/ui/card";
import { Badge } from "../components/ui/badge";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "../components/ui/table";

export default function CashFlow() {
  const { t, fmt, entity } = useApp();
  const [data, setData] = useState(null);

  useEffect(() => {
    setData(null);
    api.get(`/reports/cashflow?entity_id=${entity}`).then((r) => setData(r.data)).catch(() => {});
  }, [entity]);

  if (!data) return <div className="text-muted-foreground">{t("common.loading")}</div>;

  return (
    <div className="space-y-6" data-testid="cashflow-page">
      <h1 className="text-2xl sm:text-3xl font-bold tracking-tight">{t("nav.cashflow")}</h1>

      <Card data-testid="cashflow-actual-card">
        <CardHeader><CardTitle>{t("cf.actual")}</CardTitle></CardHeader>
        <CardContent>
          {data.series.length === 0 ? <div className="text-sm text-muted-foreground">{t("common.noData")}</div> : (
            <Table>
              <TableHeader>
                <TableRow>
                  <TableHead>{t("cf.month")}</TableHead>
                  <TableHead className="text-right">{t("dash.inflow")}</TableHead>
                  <TableHead className="text-right">{t("dash.outflow")}</TableHead>
                  <TableHead className="text-right">{t("dash.net")}</TableHead>
                </TableRow>
              </TableHeader>
              <TableBody>
                {data.series.map((s) => (
                  <TableRow key={s.month} data-testid={`cf-row-${s.month}`}>
                    <TableCell className="font-mono">{s.month}</TableCell>
                    <TableCell className="text-right font-mono text-emerald-500">{fmt(s.inflow)}</TableCell>
                    <TableCell className="text-right font-mono text-red-500">{fmt(s.outflow)}</TableCell>
                    <TableCell className="text-right font-mono font-semibold">{fmt(s.net)}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          )}
        </CardContent>
      </Card>

      <Card data-testid="cashflow-forecast-card">
        <CardHeader><CardTitle>{t("cf.forecast")}</CardTitle></CardHeader>
        <CardContent>
          {data.forecast.length === 0 ? <div className="text-sm text-muted-foreground">{t("common.noData")}</div> : (
            <Table>
              <TableHeader>
                <TableRow>
                  <TableHead>{t("common.number")}</TableHead>
                  <TableHead>{t("contacts.title").split(" ")[0]}</TableHead>
                  <TableHead>{t("common.type")}</TableHead>
                  <TableHead>{t("common.dueDate")}</TableHead>
                  <TableHead className="text-right">{t("common.amount")}</TableHead>
                </TableRow>
              </TableHeader>
              <TableBody>
                {data.forecast.map((f) => (
                  <TableRow key={f.id} data-testid={`forecast-row-${f.id}`}>
                    <TableCell className="font-mono">{f.number}</TableCell>
                    <TableCell>{f.counterparty}</TableCell>
                    <TableCell>
                      <Badge variant={f.kind === "sale" ? "default" : "secondary"}>
                        {f.kind === "sale" ? t("inv.sale") : t("inv.purchase")}
                      </Badge>
                    </TableCell>
                    <TableCell className="font-mono">{f.due_date}</TableCell>
                    <TableCell className={`text-right font-mono font-semibold ${f.kind === "sale" ? "text-emerald-500" : "text-red-500"}`}>
                      {f.kind === "sale" ? "+" : "-"}{fmt(f.amount)}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
